import contractService from "../services/contractService";
import {
  isTerminalDocumentStatus,
  removeTrackedDocumentJob,
  updateTrackedDocumentJob,
} from "./documentJobTracker";

const DEFAULT_INTERVAL_MS = 3000;
const DEFAULT_TIMEOUT_MS = 5 * 60 * 1000;

/**
 * Poll GET document by job_id until PDF_GENERATED (or terminal / timeout).
 */
export async function pollDocumentJobStatus(jobId, options = {}) {
  const {
    intervalMs = DEFAULT_INTERVAL_MS,
    timeoutMs = DEFAULT_TIMEOUT_MS,
    onStatus,
    signal,
  } = options;

  if (!jobId) {
    return { ok: false, reason: "missing_job_id" };
  }

  const started = Date.now();

  while (Date.now() - started < timeoutMs) {
    if (signal?.aborted) {
      return { ok: false, reason: "aborted" };
    }

    const result = await contractService.getDocumentByJobId(jobId);
    if (result?.success && result.data) {
      const status = result.data.status;
      onStatus?.(status, result.data);
      updateTrackedDocumentJob(jobId, { status });

      if (status === "PDF_GENERATED") {
        removeTrackedDocumentJob(jobId);
        return { ok: true, status, data: result.data };
      }

      if (isTerminalDocumentStatus(status) && status !== "PDF_GENERATED") {
        removeTrackedDocumentJob(jobId);
        return { ok: false, status, reason: "terminal_status", data: result.data };
      }
    }

    await new Promise((resolve) => {
      const t = setTimeout(resolve, intervalMs);
      if (signal) {
        signal.addEventListener(
          "abort",
          () => {
            clearTimeout(t);
            resolve();
          },
          { once: true }
        );
      }
    });
  }

  updateTrackedDocumentJob(jobId, { status: "timeout" });
  return { ok: false, reason: "timeout" };
}
